import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import JTLogo from "./JTLogo";

export const SiteHeader = ({ minimal = false }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        background: scrolled ? "rgba(0,0,0,0.85)" : "transparent",
        backdropFilter: scrolled ? "blur(16px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(201,162,75,0.12)" : "1px solid transparent",
      }}
    >
      <div className="max-w-[1240px] mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-home-link">
          <JTLogo size={36} />
          <span
            className="font-label gold-text hidden sm:inline"
            style={{ fontSize: "10px", letterSpacing: "0.42em" }}
          >
            JUMPSEAT THERAPY
          </span>
        </Link>

        {!minimal && (
          <nav className="flex items-center gap-8">
            <Link to="/apply" className="jt-nav-link" data-testid="header-apply-link">
              Request Membership
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default SiteHeader;
